import { Expression, NamedColumn } from '../../../types';

export default function noLinkedTasksHandler(
  column: NamedColumn, expression: Expression,
): Expression {
  return {
    ...expression,
    field: column.identifier(),
    operator: 'is_empty',
  };
}
